module.exports = __webpack_public_path__ + "img/doctor.65dba2d5.png";